"use client";

import React, { useState } from "react";
import { ZoomIn } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type GalleryItem = {
  id: number;
  src: string;
  alt: string;
  caption: string;
};
const galleryItems: GalleryItem[] = [{
  id: 1,
  src: "https://babebloombarco.com/wp-content/uploads/2026/06/IMG_5431-scaled.jpg?v=f9mkovft44g",
  alt: "Bridal Shower, Nashville",
  caption: "A dreamy bridal shower setup featuring our signature blush and rose blooms."
}, {
  id: 2,
  src: "https://babebloombarco.com/wp-content/uploads/2026/06/IMG_5517-scaled.jpg?v=qbak53snlok",
  alt: "Wedding Flower Bar, Clarksville",
  caption: "Interactive bouquet building for a luxury wedding celebration."
}, {
  id: 3,
  src: "https://babebloombarco.com/wp-content/uploads/2026/08/1AF70D42-8CA7-4C18-A54B-FF989D98908C_1_105_c.jpeg?v=fgq90af4236",
  alt: "Corporate Event, Middle Tennessee",
  caption: "Sophisticated floral arrangements with champagne gold detailing."
}, {
  id: 4,
  src: "https://babebloombarco.com/wp-content/uploads/2026/06/IMG_6498-scaled.jpg?v=fumdtlcuwyu",
  alt: "Baby Shower, Hopkinsville",
  caption: "Soft rose and cream palettes for a romantic baby shower experience."
}, {
  id: 5,
  src: "https://babebloombarco.com/wp-content/uploads/2026/06/IMG_6506-scaled.jpg?v=m4b6zlgojdk",
  alt: "Bachelorette Party, Nashville",
  caption: "The ultimate photo-worthy flower bar for a Nashville bachelorette."
}, {
  id: 6,
  src: "https://babebloombarco.com/wp-content/uploads/2026/06/IMG_6489-scaled.jpg?v=x5oblzq2er",
  alt: "Luxury Floral Detail",
  caption: "Capturing the intricate beauty of our premium, hand-selected stems."
}];
export default function MomentsInBloom() {
  const [selectedImage, setSelectedImage] = useState<GalleryItem | null>(null);
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: galleryRef,
    isVisible: isGalleryVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return <section data-section-id="222229" id="moments-in-bloom" className="bg-background text-foreground py-24 md:py-32 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-20 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold tracking-widest text-primary mb-6">
            Moments in Bloom
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-serif leading-relaxed">A curated collection of our most enchanting floral experiences. From intimate bridal showers in Nashville to beautiful Pop Ups in Clarksville, explore the artistry and elegance of Babe Bloom Bar Co.</p>
        </div>

        {}
        <div ref={galleryRef} className={`columns-1 md:columns-2 lg:columns-3 gap-12 transition-all duration-1000 delay-200 ease-out ${isGalleryVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {galleryItems.map((item, i) => <div key={item.id} data-index={i} className="break-inside-avoid mb-12 group relative cursor-pointer overflow-hidden rounded-lg shadow-md" onClick={() => setSelectedImage(item)}>
              <img src={item.src} alt={item.alt} className="w-full h-auto object-cover transition-transform duration-700 ease-in-out group-hover:scale-105" loading="lazy" />
              
              {}
              <div className="absolute inset-0 bg-primary/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col items-center justify-center p-6 text-center">
                <span className="text-white font-default font-semibold text-lg mb-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                  {item.alt}
                </span>
                <div className="bg-white/90 text-primary p-3 rounded-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-75">
                  <ZoomIn className="w-5 h-5" strokeWidth={2} />
                </div>
              </div>
            </div>)}
        </div>
      </div>

      {}
      <Dialog open={!!selectedImage} onOpenChange={open => !open && setSelectedImage(null)}>
        <DialogContent className="max-w-[95vw] md:max-w-[85vw] h-[95vh] p-0 border-none bg-transparent flex flex-col justify-center items-center" showCloseButton={true}>
          {}
          <DialogTitle className="sr-only">
            {selectedImage?.alt || "Full screen floral gallery image"}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {selectedImage?.caption || "Detailed view of our luxury flower bar setup"}
          </DialogDescription>

          {selectedImage && <div className="relative w-full h-full flex flex-col items-center justify-center animate-in fade-in zoom-in-95 duration-300">
              <img src={selectedImage.src} alt={selectedImage.alt} className="max-w-full max-h-[80vh] object-contain shadow-2xl rounded-lg" />
              <div className="mt-8 text-center max-w-2xl px-4">
                <p className="text-white font-serif text-xl md:text-2xl tracking-wide font-light drop-shadow-lg">
                  {selectedImage.caption}
                </p>
              </div>
            </div>}
        </DialogContent>
      </Dialog>
    </section>;
}